import clsx from 'clsx'

import type { FC, ReactNode } from 'react'

type GridProps = {
  className?: string
  childrenLeft: ReactNode
  childrenLeftProps?: any
  childrenRight: ReactNode
  childrenRightProps?: any
}

const Grid: FC<GridProps> = ({
  className,
  childrenLeft,
  childrenLeftProps,
  childrenRight,
  childrenRightProps,
  ...props
}) => {
  return (
    <div
      className={clsx('grid grid-cols-8 gap-4 items-center', className)}
      {...props}
    >
      <div className="col-span-5" {...childrenLeftProps}>
        {childrenLeft}
      </div>
      <div className="col-span-3" {...childrenRightProps}>
        {childrenRight}
      </div>
    </div>
  )
}

export default Grid
